import BaseErrorHandler from '@/apis/errorHandler/handler/BaseErrorHandler'
import  AlertTypeEnum from '@/apis/errorHandler/AlertTypeEnum'

export default class InvalidOperationException extends BaseErrorHandler {
    protected Code: string = "InvalidOperation";
    protected AlertType:AlertTypeEnum=AlertTypeEnum.ERROR;

    customizeAction(): void {
    }
}
